import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Cache module-level to avoid multiple requests per session
let _cache = null;
let _pending = null;

async function fetchSettings() {
  if (_cache) return _cache;
  if (_pending) return _pending;
  _pending = api.get("/settings/public").then(({ data }) => {
    _cache = data;
    _pending = null;
    return data;
  }).catch(() => {
    _pending = null;
    return {};
  });
  return _pending;
}

export function usePublicSettings() {
  const [settings, setSettings] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    fetchSettings().then(setSettings);
  }, []);
  return settings || {};
}

export function usePrepTime() {
  const s = usePublicSettings();
  return Number(s?.prep_time_minutes ?? 20);
}
